import * as React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function Header(props) {
  const { sections, title } = props;

  return (
    <React.Fragment>
      <Toolbar sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Typography
          component="h2"
          variant="h5"
          color="inherit"
          align="center"
          noWrap
          sx={{ flex: 1, fontWeight: 'bold' }}
        >

          {/* タイトルをリンクに変更 */}
          <Link href="/" color="inherit" underline="none" // 下線なし
            sx={{
              '&:hover': {
                opacity: 0.8  // ホバー時に少し透明度を変えてクリック可能なことを示す
              }
            }}
          >
            {title}
          </Link>
        </Typography>
      </Toolbar>
      <Toolbar
        component="nav"
        variant="dense"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          overflowX: 'auto',
          px: 2,
          maxWidth: '700px', // 最大幅を制限
          margin: '0 auto', // 中央揃え
        }}
      >

        {sections.map((section) => (
          <Link
            color="inherit"
            noWrap
            key={section.title}
            variant="body2"
            href={section.url}
            // sx={{ p: 1, flexShrink: 0 }}
            sx={{
              p: 1,
              flexShrink: 0,
              fontSize: '0.9rem', // フォントサイズ
              fontWeight: 450 // やや太く
            }}
          >
            {section.title}
          </Link>
        ))}
      </Toolbar>
    </React.Fragment>
  );
}

Header.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default Header;